import { Pipe, PipeTransform } from '@angular/core';
import { FileEventType } from '../../common/type/file-event-type';

@Pipe({ name: 'fileEventType' })
export class FileEventTypePipe implements PipeTransform {
  transform(obj: any, args?: any): any {
    let result = null;
    switch (obj) {
      case '0':
      case FileEventType[FileEventType.CREATED]:
        result = '파일생성';
        break;
      case '1':
      case FileEventType[FileEventType.DELETED]:
        result = '파일삭제';
        break;
      case '2':
      case FileEventType[FileEventType.DISCOVERY]:
        result = '파일발견';
        break;
      case '3':
      case FileEventType[FileEventType.DECRYPTION]:
        result = '파일접근';
        break;
      case '4':
      case FileEventType[FileEventType.EXPIRE]:
        result = '만료기한';
        break;
      case '5':
      case FileEventType[FileEventType.NOTAUTHROIZED]:
        result = '비인가접근';
      case '6':
      case FileEventType[FileEventType.FOCUSMATERIAL]:
        result = '집중관리';
        break;
      case '7':
      case FileEventType[FileEventType.RESIZE]:
        result = '파일변경';
        break;
      case '8':
      case FileEventType[FileEventType.VAULT]:
        result = '파일보관';
        break;
      case '9':
      case FileEventType[FileEventType.BACKUP]:
        result = '파일백업';
        break;
      case '10':
      case FileEventType[FileEventType.EXPORT]:
        result = '반출';
        break;
      case '11':
      case FileEventType[FileEventType.EXPORT_ITEM]:
        result = '반출파일';
        break;
      case '12':
      case FileEventType[FileEventType.IMPORT]:
        result = '반입';
        break;
      case '13':
      case FileEventType[FileEventType.IMPORT_ITEM]:
        result = '반입파일';
        break;
      default:
        result = obj;
    }
    return result;
  }
}
